export default httpClient => ({
  informacoes: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/dashboard', { headers });
    return {
      data: response.data
    }
  }
});